import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["metric", "chart", "refreshButton"];

  connect() {
    console.log("Admin dashboard controller connected");
    this.startAutoRefresh();
  }

  disconnect() {
    this.stopAutoRefresh();
  }

  refreshData() {
    // Add loading state
    if (this.hasRefreshButtonTarget) {
      this.refreshButtonTarget.disabled = true;
      this.refreshButtonTarget.innerHTML = `
        <svg class="animate-spin h-4 w-8 ml-8" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Refreshing...
      `;
    }

    // Refresh the page to get updated data
    window.location.reload();
  }

  startAutoRefresh() {
    // Auto-refresh every 10 minutes to avoid constant page reloads
    this.refreshInterval = setInterval(() => {
      console.log("Auto-refreshing dashboard data...");
      window.location.reload();
    }, 600000); // Refresh every 10 minutes
  }

  stopAutoRefresh() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  }
}
